interface CacheEntry<T> {
  data: T;
  timestamp: number;
}

export class DataCache {
  private entries = new Map<string, CacheEntry<any>>();
  private ttlMs: number;

  constructor(ttlMs: number) {
    this.ttlMs = ttlMs;
  }

  get<T>(key: string): T | null {
    const entry = this.entries.get(key);
    if (!entry) return null;
    if (Date.now() - entry.timestamp > this.ttlMs) {
      this.entries.delete(key);
      return null;
    }
    return entry.data;
  }

  set<T>(key: string, data: T): void {
    this.entries.set(key, { data, timestamp: Date.now() });
  }

  /**
   * Invalidate a specific cache entry, or clear the entire cache when no
   * key is provided. Called after any mutation (upsert/create/delete/sync)
   * so subsequent reads see fresh data instead of waiting for the TTL.
   */
  invalidate(key?: string): void {
    if (key === undefined) {
      this.entries.clear();
      return;
    }
    this.entries.delete(key);
  }

  isFresh(key: string): boolean {
    return this.get(key) !== null;
  }
}
